import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { capitalizeFirstLetter, getLandlordTransactionFor, truncateText } from "../../helpers";
import moment from "moment";
import { getModeName } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";
import { handleCopy } from "../../helpers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PendingPaymentTable = ({
  apiData,
  setSelectedData,
  handleMarkAsPaid
}) => {
  useEffect(() => {
    setCurrentPage(0);
  }, [apiData]);

  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const ActionBtns = (item) => {
    return (
      <div className="flex gap-4 ">
        <button
          onClick={() => {
            handleMarkAsPaid(item);
          }}
          className={`text-sm px-4 py-1 rounded-lg ${item.canPayOnline === false ? ' text-gray-500 border-gray-400' : 'text-green-600 cursor-pointer border-green-600 bg-green-50'} flex items-center gap-1 border `}
        >
          Pay
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        room: item.roomNum,
        property: getProperty(item),//item?.propName ? truncateText(item.propName, 25) : "-",
        clientName: clientName(item),
        dueOn: <span className='text-gray-600 text-sm'>{moment(item.dueDate).format("DD, MMM YY")}</span>,
        // dueOn: (
        //   <span className="text-sm text-gray-600">
        //     {moment(item.dueDate).format("DD, MMM YY")}
        //     {moment(item.dueDate).isBefore(moment(), "day") && (
        //       <span className="ml-2 text-xs text-rose-600 font-medium">
        //         Overdue
        //       </span>
        //     )}
        //   </span>
        // ),
        amount: <Amount>{'₹' + item.balance}</Amount>,
        mode: getPaymentModeX(getModeName(item.mode)),
        transactionFor1: <span className="text-sm text-gray-600">{item.name}</span>,
        transactionFor: getLandlordTransactionFor(item),
        status: getStatus(item.status),
        //downloadReceipt: downloadReceipt(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);


  const getProperty = (item) => {
    const name = capitalizeFirstLetter(item?.propName || '--');
    return (
      <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
        {truncateText(name, 35)}{" "}
      </span>
    );
  };

  const getPaymentModeX = (mode, recordedBy) => {
    return (<div className="flex flex-col gap-0">
      <span className="text-gray-600 text-sm font-medium">
        {mode}{" "}
      </span>
      {/* {recordedBy && recordedBy === 'Kipinn App' ? <span className="text-primary-color text-sm">{"Recorded by " + recordedBy}</span>
        :
        <span className="text-gray-400 text-sm">{"Recorded by " + recordedBy}</span>
      } */}
    </div>);
  };
  const goToSummary = (item) => {
    navigate(`/landlord/details`, {
      state: {
        landlordId: item.landlordId,
      },
    });
  };

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.landlordName || "N/A");

    return (
      <UserImageWrapper
        className="cursor-pointer"
        onClick={() => goToSummary(item)}
      >
        <UserImage src={Images.Avatar} alt={name} />

        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-800 truncate max-w-[180px]">
            {name}
          </span>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            <span>#{item.landlordMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.landlordMobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };


  const getNameOld = (item) => {
    const name = capitalizeFirstLetter(item?.landlordName || 'N/A');
    return (
      <UserImageWrapper className="cursor-pointer"
        onClick={() => goToSummary(item)}
      >
        <UserImage src={Images.Avatar} alt={`Avatar for ${item.landlordName}`} />
        <div className="flex flex-col gap-1">
          <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
            {truncateText(name, 35)}{""}
          </span>
          <div className="flex gap-1 items-center">
            <span className="text-gray-400 text-xs">#{item.landlordMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.landlordMobile);
              }}
              className="p-1"
            >
              <IoCopySharp size={10} className="text-gray-400" />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getPropName = (item) => {
    if (item?.propertyName)
      return (
        <div className="flex flex-col">
          <span>{truncateText(item.propertyName, 25)} </span>
        </div>
      );
    else
      return "-";
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const clientName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-zinc-900 font-semibold">{item.clientName}</p>
        <p className="text-amber-500 text-xs">#{item.clientMobile}</p>
      </div>
    );
  };

  const getAmount = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <Amount>₹{item?.amount}</Amount>
        {/* {item?.docs &&
          <button className="text-primary-color underline text-sm text-left"
            onClick={() => downloadBill(item.docs)}>Uploaded Receipt</button>
        } */}
      </div>
    )
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Pending>Pending</Pending>;
    } else if (status === 2) {
      return <Resolve>SUCCESS</Resolve>;
    } else {
      return <Inprogress>FAILED</Inprogress>;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Landlord",
          accessor: "name",
        },

        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Landlord",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "property",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        //Header: "TRANS ID/ Desc",
        Header: "For",
        accessor: "transactionFor",
      },
      // {
      //   Header: "Mode",
      //   accessor: "mode",
      // },
      {
        Header: "Due On",
        accessor: "dueOn",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                        style={{ maxWidth: "320px" }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Category:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Mode:</strong> {data[rowIndex].mode}
                        </li>
                        <li className="flex gap-2">
                          <strong>Date:</strong> {data[rowIndex].dueOn}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
const Inprogress = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded`;
const Resolve = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;
//const Amount = tw.p`text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex`
const Amount = tw.p`
  text-rose-700
  bg-rose-50
  text-sm
  font-semibold
  px-3
  py-1
  rounded-full
  inline-flex
  whitespace-nowrap
`;

export default PendingPaymentTable;
